var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQrCodeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 42H13V44H4V35H6V42ZM44 44H35V42H42V35H44V44ZM19 39H9V29H19V39ZM23 39H21V37H23V39ZM39 39H37V9H39V39ZM11 37H17V31H11V37ZM15 35H13V33H15V35ZM23 35H21V33H23V35ZM27 33H25V9H27V33ZM31 33H29V9H31V33ZM35 33H33V9H35V33ZM23 31H21V25H23V31ZM11 27H9V25H11V27ZM15 27H13V23H9V21H15V27ZM19 25V27H17V25H19ZM23 23H17V21H21V17H23V23ZM19 19H9V9H19V19ZM11 17H17V11H11V17ZM15 15H13V13H15V15ZM23 15H21V9H23V15ZM13 6H6V13H4V4H13V6ZM44 13H42V6H35V4H44V13Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQrCodeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/QR_Code_Icon.c3e3eec02162dd132c2e73e398ddfefc.svg";